import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/Home.vue';
import Login from './components/Login.vue';

import Players from './components/Players.vue';
import PlayerFind from './components/PlayerFind.vue';
import PlayersPendings from './components/PlayersPendings.vue';
import PlayersPendingAdd from './components/PlayersPendingAdd.vue';
import PlayersPendingAddFollowLink from './components/PlayersPendingAddFollowLink.vue';
import PlayersPendingAddForVip from './components/PlayersPendingAddForVip.vue';
import PlayersPaymentRestores from './components/PlayersPaymentRestores.vue';
import SuspectedPlayers from './components/SuspectedPlayers.vue';
import SuspectedPlayersBanAdd from './components/SuspectedPlayersBanAdd.vue';
import PlayersEventAccessBlocking from './components/PlayersEventAccessBlocking.vue';

import MassPending     from './components/MassPending.vue';
import MassPendingInfo from './components/MassPendingInfo.vue';
import MassPendingPlayers from './components/MassPendingPlayers.vue';

import Player from './components/Player.vue';
import PlayerState from './components/PlayerState.vue';
import PlayerStateEditor from './components/PlayerStateEditor.vue';
import PlayerClientIdentities from './components/PlayerClientIdentities.vue';
import PlayerClientIdentityAdd from './components/PlayerClientIdentityAdd.vue';
import PlayerRestorations from './components/PlayerRestorations.vue';
import PlayerOrders from './components/PlayerOrders.vue';
import PlayerPaymentIntents from './components/PlayerPaymentIntents.vue';
import PlayerClientPayments from './components/PlayerClientPayments.vue';
import PlayerBilling from './components/PlayerBilling.vue';
import PlayerInventory from './components/PlayerInventory.vue';
import PlayerInventoryItemEdit from './components/PlayerInventoryItemEdit.vue';
import PlayerInventoryEdit from './components/PlayerInventoryEdit.vue';
import PlayerResourceLog from './components/PlayerResourceLog.vue';
import PlayerResourceLogCopies from './components/PlayerResourceLogCopies.vue';
import PlayerResourceLogCopy from './components/PlayerResourceLogCopy.vue';
import PlayerEquipment from './components/PlayerEquipment.vue';
import PlayerSystem from './components/PlayerSystem.vue';
import PlayerBanLog from './components/PlayerBanLog.vue';
import PlayerBan from './components/PlayerBan.vue';
import PlayerBanAdd from './components/PlayerBanAdd.vue';
import PlayerUnbanAdd from './components/PlayerUnbanAdd.vue';
import PlayerUnban from './components/PlayerUnban.vue';
import PlayerLevelDecrements from './components/level_decrement/PlayerLevelDecrements.vue';
import PlayerEmergencyStateLog from './components/PlayerEmergencyStateLog.vue';
import PlayerPendings from './components/PlayerPendings.vue';
import PlayerPendingAdd from './components/PlayerPendingAdd.vue';
import PlayerInfo from './components/PlayerInfo.vue';
import PlayerLevelEdit from './components/PlayerLevelEdit.vue';
import PlayerEventAccessStatusEdit from './components/PlayerEventAccessStatusEdit.vue';
import PlayerEvents from './components/PlayerEvents.vue';
import PlayerContests from './components/PlayerContests.vue';
import PlayerRushes from './components/PlayerRushes.vue';
import PlayerDeviceTokenInfo from './components/PlayerDeviceTokenInfo.vue';
import PlayerDeviceTokenEdit from './components/PlayerDeviceTokenEdit.vue';
import PlayerLimits from './components/PlayerLimits.vue';
import PlayerOffers from './components/PlayerOffers.vue';
import PlayerOffersOld from './components/PlayerOffersOld.vue';
import PlayerOfferOld from './components/PlayerOfferOld.vue';
import PlayerMesas from './components/PlayerMesas.vue';
import PlayerDerbies from './components/race/PlayerDerbies.vue';
import PlayerTmnts from './components/PlayerTmnts.vue';
import PlayerContestLog from './components/PlayerContestLog.vue';
import PlayerContestsRewards from './components/PlayerContestsRewards.vue';
import PlayerAds from './components/PlayerAds.vue';
import PlayerUsersActions from './components/PlayerUsersActions.vue';
import PlayerLevelFinishedEvents from './components/PlayerLevelFinishedEvents.vue';
import PlayerAppSessionsLog from './components/PlayerAppSessionsLog.vue';
import PlayerNetSessionsLog from './components/PlayerNetSessionsLog.vue';
import PlayerClubGifts from './components/PlayerClubGifts.vue';
import PlayerInComplaints from './components/PlayerInComplaints.vue';
import PlayerWinStreaks from './components/PlayerWinStreaks.vue';
import PlayerSeasons from './components/PlayerSeasons.vue';
import PlayerIndividualSeasons from './components/PlayerIndividualSeasons.vue';
import PlayerGvnts from './components/PlayerGvnts.vue';
import PlayerRegattas from './components/regatta/PlayerRegattas.vue';

import PlayerChatBlockLog   from './components/PlayerChatBlockLog.vue';
import PlayerChatBlock      from './components/PlayerChatBlock.vue';
import PlayerChatUnblock    from './components/PlayerChatUnblock.vue';
import PlayerChatUnblockAdd from './components/PlayerChatUnblockAdd.vue';

import Pushes from './components/Pushes.vue';
import PushesUser from './components/PushesUser.vue';
import UserPushLog from './components/UserPushLog.vue';
import PushesAuto from './components/PushesAuto.vue';
import PushAdd from './components/PushAdd.vue';
import PushEdit from './components/PushEdit.vue';
import Push     from './components/Push.vue';
import PushInfo from './components/PushInfo.vue';
import PushJobs from './components/PushJobs.vue';

import Billing from './components/Billing.vue';
import ClubSection from './components/ClubSection.vue';
import ClubSearch from './components/ClubSearch.vue';
import ClubSuggestion from './components/ClubSuggestion.vue';
import LastClubs from './components/LastClubs.vue';
import ActiveClubs from './components/ActiveClubs.vue';
import ClubsComplainees from './components/ClubsComplainees.vue';
import Club from './components/Club.vue';
import ClubInfo from './components/ClubInfo.vue';
import ClubMembers from './components/ClubMembers.vue';
import ClubChat from './components/ClubChat.vue';
import ClubChatCopies from './components/ClubChatCopies.vue';

import Events from './components/Events.vue';

import Contests           from './components/Contests.vue';
import ContestAdd         from './components/ContestAdd.vue';
import GvntTmntAdd        from './components/GvntTmntAdd.vue';
import ContestsImportLog  from './components/ContestsImportLog.vue';
import Contest            from './components/Contest.vue';
import ContestInfo        from './components/ContestInfo.vue';
import ContestEdit        from './components/ContestEdit.vue';
import ContestStat        from './components/ContestStat.vue';
import ContestGroupSearch from './components/ContestGroupSearch.vue';
import ContestGroups      from './components/ContestGroups.vue';
import ContestGroup       from './components/ContestGroup.vue';
import ContestChampGross  from './components/ContestChampGross.vue';

import ContestPlayer             from './components/ContestPlayer.vue';
import ContestPlayerInfo         from './components/ContestPlayerInfo.vue';
import ContestPlayerScoreHistory from './components/ContestPlayerScoreHistory.vue';
import ContestPlayerRewards      from './components/ContestPlayerRewards.vue';

import Rushes         from './components/Rushes.vue';
import RushAdd        from './components/RushAdd.vue';
import Rush           from './components/Rush.vue';
import RushInfo       from './components/RushInfo.vue';
import RushEdit       from './components/RushEdit.vue';
import RushStat       from './components/RushStat.vue';
import RushRaces      from './components/RushRaces.vue';
import RushRace       from './components/RushRace.vue';
import RushRaceInfo   from './components/RushRaceInfo.vue';
import RushRaceRating from './components/RushRaceRating.vue';

import RushPlayer      from './components/RushPlayer.vue';
import RushPlayerInfo  from './components/RushPlayerInfo.vue';
import RushPlayerRaces from './components/RushPlayerRaces.vue';

import RushRacePlayer             from './components/RushRacePlayer.vue';
import RushRacePlayerInfo         from './components/RushRacePlayerInfo.vue';
import RushRacePlayerScoreHistory from './components/RushRacePlayerScoreHistory.vue';

import Mesas       from './components/Mesas.vue';
import MesaAdd     from './components/MesaAdd.vue';
import Mesa        from './components/Mesa.vue';
import MesaInfo    from './components/MesaInfo.vue';
import MesaEdit    from './components/MesaEdit.vue';

import Gvnts    from './components/Gvnts.vue';
import GvntAdd  from './components/GvntAdd.vue';
import GvntEdit  from './components/GvntEdit.vue';
import Gvnt     from './components/Gvnt.vue';
import GvntInfo from './components/GvntInfo.vue';
import GvntEditClientMinVersion from './components/GvntEditClientMinVersion.vue';

import Seasons    from './components/Seasons.vue';
import SeasonAdd  from './components/SeasonAdd.vue';
import Season     from './components/Season.vue';
import SeasonInfo from './components/SeasonInfo.vue';
import SeasonCommonScoreCorrectionEditor from './components/SeasonCommonScoreCorrectionEditor.vue';

import UpdateOffers from './components/UpdateOffers.vue';
import UpdateOfferAdd from './components/UpdateOfferAdd.vue';

import WinStreaks    from './components/WinStreaks.vue';
import WinStreakAdd  from './components/WinStreakAdd.vue';
import WinStreak     from './components/WinStreak.vue';
import WinStreakInfo from './components/WinStreakInfo.vue';

import DailyQuestsTimetable from './components/DailyQuests/Timetable.vue';
import AddDailyQuestsTimetableRecord from './components/DailyQuests/AddTimetableRecord.vue';
import EditDailyQuestsTimetableRecord from './components/DailyQuests/EditTimetableRecord.vue';

import Derbies           from './components/race/Derbies.vue';
import DerbyList         from './components/race/DerbyList.vue';
import DerbyAdd          from './components/race/DerbyAdd.vue';
import DerbyTemplateList from './components/race/DerbyTemplateList.vue';
import DerbyTemplateAdd  from './components/race/DerbyTemplateAdd.vue';
import DerbyTemplateEdit from './components/race/DerbyTemplateEdit.vue';
import Derby             from './components/race/Derby.vue';
import DerbyInfo         from './components/race/DerbyInfo.vue';
import DerbyLeagueList   from './components/race/DerbyLeagueList.vue';
import DerbyRaceList     from './components/race/DerbyRaceList.vue';
import DerbyRace         from './components/race/DerbyRace.vue';
import DerbyRaceInfo     from './components/race/DerbyRaceInfo.vue';
import DerbyRaceRating   from './components/race/DerbyRaceRating.vue';
import DerbyPlayer       from './components/race/DerbyPlayer.vue';
import DerbyPlayerInfo   from './components/race/DerbyPlayerInfo.vue';
import DerbyPlayerRaces  from './components/race/DerbyPlayerRaces.vue';

import RiverRumble                     from './components/RiverRumble/RiverRumble.vue';
import RiverRumbleTimetable            from './components/RiverRumble/Timetable.vue'
import RiverRumbleTimetableAddRecord   from './components/RiverRumble/TimetableAddRecord.vue';
import RiverRumbleTimetableEditRecord  from './components/RiverRumble/TimetableEditRecord.vue';
import RiverRumbleDevGeneratePlayers   from './components/RiverRumble/DevGeneratePlayers.vue';
import RiverRumbleDevGenerateStats     from './components/RiverRumble/DevGenerateStats.vue';
import RiverRumbleDevTestRandomPlayers from './components/RiverRumble/DevTestRandomPlayers.vue';
import RiverRumbleDevTestSimulateJoin  from './components/RiverRumble/DevTestSimulateJoin.vue';
import RiverRumbleAverageFails         from './components/RiverRumble/AverageFails.vue';

import M3Replays from './components/M3Replays.vue';

import System from './components/System.vue';
import SystemClientMinVersion from './components/SystemClientMinVersion.vue';
import SystemMaintenance from './components/SystemMaintenance.vue';
import SystemPlayersNetSessionsLogConf from './components/SystemPlayersNetSessionsLogConf.vue';
import SystemInfoInsiderClient from './components/SystemInfoInsiderClient.vue';
import SystemInfoInsiderServer from './components/SystemInfoInsiderServer.vue';
import SystemInfoGameServer from './components/SystemInfoGameServer.vue';
import SystemInfoPushServer from './components/SystemInfoPushServer.vue';
import SystemLevelsRevisions from './components/SystemLevelsRevisions.vue';
import SystemRedisConnectionStat from './components/SystemRedisConnectionStat.vue';
import SystemStat from './components/SystemStat.vue';
import MonthPayerGroups from './components/MonthPayerGroups.vue';
import MonthPayerGroup from './components/MonthPayerGroup.vue';
import SystemTest from './components/SystemTest.vue';

import LevelDecrements from './components/level_decrement/LevelDecrements.vue';
import EmergencyStateLog from './components/EmergencyStateLog.vue';
import QAUsers from './components/QAUsers.vue';
import QAUserAdd from './components/QAUserAdd.vue';
import QAUserEdit from './components/QAUserEdit.vue';
import Users from './components/Users.vue';
import UserAdd from './components/UserAdd.vue';
import User from './components/User.vue';
import UserInfo from './components/UserInfo.vue';
import UserActions from './components/UserActions.vue';
import UserChangePassword from './components/UserChangePassword.vue';
import UserEdit from './components/UserEdit.vue';
import Levels from './components/m3/Levels.vue';
import Level from './components/m3/Level.vue';
import LevelVar from './components/m3/LevelVar.vue';
import Revision from './components/m3/Revision.vue';
import LevelsConfPanel from './components/m3/LevelsConfPanel.vue';
import ReportsBuildingPanel from './components/m3/ReportsBuildingPanel.vue';
import InvalidLevelProtoNames from './components/m3/InvalidLevelProtoNames.vue';
import ErrorPage from './components/Error.vue';
import auth from './auth';
import { setUnauthorizedHandler } from './http-common';
import protoManager from './proto-manager';

import { parseUint32               } from './util.js';
import { convertCSVStringToNumbers } from './util.js';

import { parseShop              } from './model/billing.js';
import { LevelId                } from './model/m3level.js';
import { LevelVarId             } from './model/m3level.js';
import { RevisionId             } from './model/m3level.js';
import { MAIN_SEQUENCE_PROTO_ID } from './model/m3level.js';

import RegattaAdd       from "@/components/regatta/RegattaAdd.vue";
import Regattas         from "@/components/regatta/Regattas";
import RegattaList      from "@/components/regatta/RegattaList";

import Regatta          from "@/components/regatta/Regatta.vue";
import RegattaInfo      from "@/components/regatta/RegattaInfo.vue";
import RegattaRoundList from "@/components/regatta/RegattaRoundList.vue";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home,
    },
    {
      name: 'login',
      path: '/login',
      component: Login,
    },

    {
      name: 'players',
      path: '/players',
      component: Players,
      redirect: {name: 'player_search'},
      children: [
        {
          name: 'player_search',
          path: 'search',
          component: PlayerFind,
        },
        {
          name: 'players_pendings',
          path: 'pendings',
          component: PlayersPendings,
        },
        {
          name: 'players_pending_add',
          path: 'pendings/add',
          component: PlayersPendingAdd,
        },
        {
          name: 'players_pending_add_follow_link',
          path: 'pendings/add_follow_link',
          component: PlayersPendingAddFollowLink,
        },
        {
          name: 'players_pending_add_for_vip',
          path: 'pendings/add_for_vip',
          component: PlayersPendingAddForVip,
        },
        {
          name: 'players_payment_restores',
          path: 'payment_restores',
          component: PlayersPaymentRestores,
        },
        {
          name: 'suspected_players',
          path: '/suspected_players',
          component: SuspectedPlayers,
          props: parsePropsSuspectedPlayers,
        },
        {
          name: 'suspected_players_ban_add',
          path: '/suspected_players/ban/add',
          component: SuspectedPlayersBanAdd,
          props: parsePropsSuspectedPlayersBanAdd,
        },
        {
          name: 'events_blocking',
          path: '/events_blocking',
          component: PlayersEventAccessBlocking,
        },
      ],
    },

    {
      path: '/mass_pending/:massPendingId',
      component: MassPending,
      props: parsePropsMassPendingId,
      redirect: {name: 'mass_pending_info'},
      children: [
        {
          name: 'mass_pending_info',
          path: 'info',
          component: MassPendingInfo,
          props: parsePropsMassPendingId,
        },
        {
          name: 'mass_pending_players',
          path: 'players',
          component: MassPendingPlayers,
          props: parsePropsMassPendingId,
        },
      ],
    },

    {
      name: 'player_find',
      path: '/player/find',
      redirect: {name: 'player_search'},
    },

    {
      path: '/player/:playerId',
      component: Player,
      props: parsePropsPlayerId,
      redirect: {name: 'player_info'},
      children: [
        {
          path: '/player/:playerId/info',
          redirect: {name: 'player_info'},
        },
        {
          name: 'player_info',
          path: '/player/:playerId',
          component: PlayerInfo,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_device_token_info',
          path: 'device_token_info',
          component: PlayerDeviceTokenInfo,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_device_token_info_edit',
          path: 'device_token_info/edit',
          component: PlayerDeviceTokenEdit,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_level_decrements',
          path: 'level_decrements',
          component: PlayerLevelDecrements,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_emergency_state_log',
          path: 'emergency_state_log',
          component: PlayerEmergencyStateLog,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_state',
          path: 'state',
          component: PlayerState,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_state_editor',
          path: 'state/edit',
          component: PlayerStateEditor,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_level_edit',
          path: 'info/level/edit',
          component: PlayerLevelEdit,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_event_access_status_edit',
          path: 'info/event_access_status/edit',
          component: PlayerEventAccessStatusEdit,
          props: parsePropsPlayerId,
        },
        
        {
          name: 'player_client_identities',
          path: 'client_identities',
          component: PlayerClientIdentities,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_client_identity_add',
          path: 'client_identities/add',
          component: PlayerClientIdentityAdd,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_restorations',
          path: 'restorations',
          component: PlayerRestorations,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_orders',
          path: 'orders',
          component: PlayerOrders,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_client_payments',
          path: 'client_payments',
          component: PlayerClientPayments,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_payment_intents',
          path: 'payment_intents',
          component: PlayerPaymentIntents,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_billing',
          path: 'billing',
          component: PlayerBilling,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_inventory',
          path: 'inventory',
          component: PlayerInventory,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_inventory_edit',
          path: 'inventory/edit',
          component: PlayerInventoryEdit,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_inventory_item_edit',
          path: 'inventory/item/:itemId/edit',
          component: PlayerInventoryItemEdit,
          props: parsePropsInventoryItemId,
        },
        {
          name: 'player_limits',
          path: 'limits',
          component: PlayerLimits,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_club_gifts',
          path: 'club_gifts',
          component: PlayerClubGifts,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_in_complaints',
          path: 'in_complaints',
          component: PlayerInComplaints,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_chat_block_log',
          path: 'chat_block_log',
          component: PlayerChatBlockLog,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_chat_block',
          path: 'chat_block_log/block/:chatBlockId',
          component: PlayerChatBlock,
          props: parsePropsChatBlockId,
        },
        {
          name: 'player_chat_unblock',
          path: 'chat_block_log/unblock/:chatUnblockId',
          component: PlayerChatUnblock,
          props: parsePropsChatUnblockId,
        },
        {
          name: 'player_chat_unblock_add',
          path: 'chat_block_log/unblock/add',
          component: PlayerChatUnblockAdd,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_resource_log',
          path: 'resource_log',
          component: PlayerResourceLog,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_resource_log_copies',
          path: 'resource_log_copies',
          component: PlayerResourceLogCopies,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_resource_log_copy',
          path: 'resource_log_copies/:copyId',
          component: PlayerResourceLogCopy,
          props: parsePropsResourceLogCopyId,
        },
        {
          name: 'player_equipment',
          path: 'equipment',
          component: PlayerEquipment,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_offers',
          path: 'offers',
          component: PlayerOffers,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_offers_old',
          path: 'offers_old',
          component: PlayerOffersOld,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_offer_old',
          path: 'offers/:offerId',
          component: PlayerOfferOld,
          props: parsePropsOfferId,
        },
        {
          name: 'player_tmnts',
          path: 'tournaments',
          component: PlayerTmnts,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_contest_log',
          path: 'contest_log',
          component: PlayerContestLog,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_contests_rewards',
          path: 'contests_rewards',
          component: PlayerContestsRewards,
          props: parsePropsPlayerId,
        },

        {
          name: 'player_ads',
          path: 'ads',
          component: PlayerAds,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_users_actions',
          path: 'users_actions',
          component: PlayerUsersActions,
          props: parsePropsPlayerId,
        },
        {
          path: 'level_finished_events',
          name: 'player_level_finished_events',
          component: PlayerLevelFinishedEvents,
          props: parsePropsPlayerLevelFinishedEvents,
        },
        {
          path: 'win_streaks',
          name: 'player_win_streaks',
          component: PlayerWinStreaks,
          props: parsePropsPlayerId,
        },
        {
          // не используется
          path: 'individual_seasons',
          name: 'player_individual_seasons',
          component: PlayerIndividualSeasons,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_app_sessions_log',
          path: 'app_sessions',
          component: PlayerAppSessionsLog,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_net_sessions_log',
          path: 'net_sessions',
          component: PlayerNetSessionsLog,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_events',
          path: 'events',
          component: PlayerEvents,
          redirect: {name: 'player_seasons'},
          children: [
            {
              name: 'player_seasons',
              path: '/player/:playerId/seasons',
              component: PlayerSeasons,
              props: parsePropsPlayerId,
            },
            {
              name: 'player_gvnts',
              path: '/player/:playerId/gvnts',
              component: PlayerGvnts,
              props: parsePropsPlayerId,
            },
            {
              name: 'player_contests',
              path: '/player/:playerId/contests',
              component: PlayerContests,
              props: parsePropsPlayerId,
            },
            {
              name: 'player_rushes',
              path: '/player/:playerId/rushes',
              component: PlayerRushes,
              props: parsePropsPlayerId,
            },
            {
              name: 'player_mesas',
              path: '/player/:playerId/mesas',
              component: PlayerMesas,
              props: parsePropsPlayerId,
            },
            {
              name: 'player_derbies',
              path: '/player/:playerId/derbies',
              component: PlayerDerbies,
              props: parsePropsPlayerId,
            },
            {
              name: 'player_regattas',
              path: '/player/:playerId/regattas',
              component: PlayerRegattas,
              props: parsePropsPlayerId,
            },
          ],
        },
        {
          name: 'player_pendings',
          path: 'pendings',
          component: PlayerPendings,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_pending_add',
          path: 'pendings/add',
          component: PlayerPendingAdd,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_system',
          path: 'system',
          component: PlayerSystem,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_ban_log',
          path: 'ban_log',
          component: PlayerBanLog,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_ban_add',
          path: 'ban_log/ban/add',
          component: PlayerBanAdd,
          props: parsePropsPlayerBanAdd,
        },
        {
          name: 'player_ban',
          path: 'ban_log/ban/:banId',
          component: PlayerBan,
          props: parsePropsBanId,
        },
        {
          name: 'player_unban_add',
          path: 'ban_log/unban/add',
          component: PlayerUnbanAdd,
          props: parsePropsPlayerId,
        },
        {
          name: 'player_unban',
          path: 'ban_log/unban/:unbanId',
          component: PlayerUnban,
          props: parsePropsUnbanId,
        },
      ]
    },
    {
      name: 'billing',
      path: '/billing',
      component: Billing,
      props: route => {
        return {
          shop: parseOptionalShopQueryParam(route.query, 'shop'),
        };
      },
    },
    {
      name: 'pushes',
      path: '/pushes',
      component: Pushes,
      redirect: {name: 'pushes_user'},
      children: [
        {
          name: 'pushes_user',
          path: 'user',
          component: PushesUser,
        },
        {
          name: 'pushes_user_log',
          path: 'user_log',
          component: UserPushLog,
        },
        {
          name: 'pushes_auto',
          path: 'auto',
          component: PushesAuto,
        },
      ],
    },
    {
      name: 'push_add',
      path: '/push/add',
      component: PushAdd,
    },
    {
      path: '/push/:pushId',
      component: Push,
      props: parsePropsPushId,
      redirect: {name: 'push_info'},
      children: [
        {
          name: 'push_info',
          path: 'info',
          component: PushInfo,
          props: parsePropsPushId,
        },
        {
          name: 'push_edit',
          path: 'info/edit',
          component: PushEdit,
          props: parsePropsPushId,
        },
        {
          name: 'push_jobs',
          path: 'jobs',
          component: PushJobs,
          props: parsePropsPushId,
        },
      ],
    },

    {
      name: 'clubs',
      path: '/clubs',
      component: ClubSection,
      redirect: {name: 'club_search'},
      children: [
        {
          name: 'club_search',
          path: 'search',
          component: ClubSearch,
        },
        {
          name: 'club_suggestion',
          path: 'suggestion',
          component: ClubSuggestion,
        },
        {
          name: 'last_clubs',
          path: 'last',
          component: LastClubs,
        },
        {
          name: 'active_clubs',
          path: 'active',
          component: ActiveClubs,
        },
        {
          name: 'clubs_complainees',
          path: 'complainees',
          component: ClubsComplainees,
        },
      ],
    },

    {
      path: '/club/:clubId',
      component: Club,
      props: parsePropsClubId,
      redirect: {name: 'club_info'},
      children: [
        {
          name: 'club_info',
          path: 'info',
          component: ClubInfo,
          props: parsePropsClubId,
        },
        {
          name: 'club_members',
          path: 'members',
          component: ClubMembers,
          props: parsePropsClubId,
        },
        {
          name: 'club_chat',
          path: 'chat',
          component: ClubChat,
          props: parsePropsClubId,
        },
        {
          name: 'club_chat_copies',
          path: 'chat_copies',
          component: ClubChatCopies,
          props: parsePropsClubId,
        },
      ],
    },

    {
      name: 'events',
      path: '/events',
      component: Events,
    },

    {
      name: 'contests',
      path: '/contests',
      component: Contests,
    },
    {
      name: 'new_contest',
      path: '/contest/new',
      component: ContestAdd,
    },
    {
      name: 'new_gvnt_contest',
      path: '/contest/new_gvnt',
      component: GvntTmntAdd,
    },
    {
      name: 'contests_import_log',
      path: '/contests/import_log',
      component: ContestsImportLog,
    },
    {
      path: '/contest/:contestId',
      component: Contest,
      props: parsePropsContestId,
      redirect: {name: 'contest_info'},
      children: [
        {
          name: 'contest_info',
          path: 'info',
          component: ContestInfo,
          props: parsePropsContestId,
        },
        {
          name: 'contest_edit',
          path: 'edit',
          component: ContestEdit,
          props: parsePropsContestId,
        },
        {
          name: 'contest_stat',
          path: 'stat',
          component: ContestStat,
          props: parsePropsContestId,
        },
        {
          name: 'contest_group_search',
          path: 'group_search',
          component: ContestGroupSearch,
          props: parsePropsContestId,
        },
        {
          name: 'contest_groups',
          path: 'groups',
          component: ContestGroups,
          props: parsePropsContestGroups,
        },
        {
          name: 'contest_champ_gross',
          path: 'gross',
          component: ContestChampGross,
          props: parsePropsContestGroups,
        },
      ],
    },

    {
      name: 'contest_group',
      path: '/contest/:contestId/group/:groupId',
      component: ContestGroup,
      props: parsePropsContestGroupId,
    },

    {
      name: 'contest_player',
      path: '/contest/:contestId/player/:playerId',
      component: ContestPlayer,
      props: parsePropsContestPlayerId,
      redirect: {name: 'contest_player_info'},
      children: [
        {
          name: 'contest_player_info',
          path: 'info',
          component: ContestPlayerInfo,
          props: parsePropsContestPlayerId,
        },
        {
          name: 'contest_player_score_history',
          path: 'score_history',
          component: ContestPlayerScoreHistory,
          props: parsePropsContestPlayerId,
        },
        {
          name: 'contest_player_rewards',
          path: 'rewards',
          component: ContestPlayerRewards,
          props: parsePropsContestPlayerId,
        },
      ],
    },

    {
      name: 'rushes',
      path: '/rushes',
      component: Rushes,
    },
    {
      name: 'new_rush',
      path: '/rush/new',
      component: RushAdd,
    },
    {
      path: '/rush/:rushId',
      component: Rush,
      props: parsePropsRushId,
      redirect: {name: 'rush_info'},
      children: [
        {
          name: 'rush_info',
          path: 'info',
          component: RushInfo,
          props: parsePropsRushId,
        },
        {
          name: 'rush_edit',
          path: 'edit',
          component: RushEdit,
          props: parsePropsRushId,
        },
        {
          name: 'rush_races',
          path: 'races',
          component: RushRaces,
          props: parsePropsRushRaces,
        },
        {
          name: 'rush_stat',
          path: 'stat',
          component: RushStat,
          props: parsePropsRushId,
        },
      ],
    },

    {
      name: 'rush_race',
      path: '/rush/:rushId/race/:raceId',
      component: RushRace,
      props: parsePropsRushRaceId,
      redirect: {name: 'rush_race_info'},
      children: [
        {
          name: 'rush_race_info',
          path: 'info',
          component: RushRaceInfo,
          props: parsePropsRushRaceId,
        },
        {
          name: 'rush_race_rating',
          path: 'rating',
          component: RushRaceRating,
          props: parsePropsRushRaceId,
        },
      ],
    },

    {
      name: 'rush_player',
      path: '/rush/:rushId/player/:playerId',
      component: RushPlayer,
      props: parsePropsRushPlayerId,
      redirect: {name: 'rush_player_info'},
      children: [
        {
          name: 'rush_player_info',
          path: 'info',
          component: RushPlayerInfo,
          props: parsePropsRushPlayerId,
        },
        {
          name: 'rush_player_races',
          path: 'races',
          component: RushPlayerRaces,
          props: parsePropsRushPlayerId,
        },
      ],
    },

    {
      name: 'rush_race_player',
      path: '/rush/:rushId/race/:raceId/player/:playerId',
      component: RushRacePlayer,
      props: parsePropsRushRacePlayerId,
      redirect: {name: 'rush_race_player_info'},
      children: [
        {
          name: 'rush_race_player_info',
          path: 'info',
          component: RushRacePlayerInfo,
          props: parsePropsRushRacePlayerId,
        },
        {
          name: 'rush_race_player_score_history',
          path: 'score_history',
          component: RushRacePlayerScoreHistory,
          props: parsePropsRushRacePlayerId,
        },
      ],
    },

    {
      name: 'mesas',
      path: '/mesas',
      component: Mesas,
    },
    {
      name: 'new_mesa',
      path: '/mesa/new',
      component: MesaAdd,
    },
    {
      path: '/mesa/:mesaId',
      component: Mesa,
      props: parsePropsMesaId,
      redirect: {name: 'mesa_info'},
      children: [
        {
          name: 'mesa_info',
          path: 'info',
          component: MesaInfo,
          props: parsePropsMesaId,
        },
        {
          name: 'mesa_edit',
          path: 'edit',
          component: MesaEdit,
          props: parsePropsMesaId,
        },
      ],
    },

    {
      name: 'gvnts',
      path: '/game_events',
      component: Gvnts,
    },
    {
      name: 'new_gvnt',
      path: '/game_event/new',
      component: GvntAdd,
    },
    {
      path: '/game_event/:gvntId',
      component: Gvnt,
      props: parsePropsGvntId,
      redirect: {name: 'gvnt_info'},
      children: [
        {
          name: 'gvnt_info',
          path: 'info',
          component: GvntInfo,
          props: parsePropsGvntId,
        },
        {
          name: 'gvnt_edit',
          path: 'edit',
          component: GvntEdit,
          props: parsePropsGvntId,
        },
        {
          name: 'gvnt_edit_client_min_version',
          path: 'edit_client_min_version',
          component: GvntEditClientMinVersion,
          props: parsePropsGvntId,
        },
      ],
    },

    {
      name: 'seasons',
      path: '/seasons',
      component: Seasons,
    },
    {
      name: 'new_season',
      path: '/season/new',
      component: SeasonAdd,
    },
    {
      path: '/season/:seasonId',
      component: Season,
      props: parsePropsSeasonId,
      redirect: {name: 'season_info'},
      children: [
        {
          name: 'season_info',
          path: '/season/:seasonId',
          component: SeasonInfo,
          props: parsePropsSeasonId,
        },
        {
          name: 'season_common_score_correction_editor',
          path: 'common_score_correction_edit',
          component: SeasonCommonScoreCorrectionEditor,
          props: parsePropsSeasonId,
        },
      ],
    },

    {
      name: 'new_update_offer',
      path: '/update_offer/new',
      component: UpdateOfferAdd,
    },
    {
      name: 'update_offers',
      path: '/update_offers',
      component: UpdateOffers
    },

    {
      name: 'win_streaks',
      path: '/win_streaks',
      component: WinStreaks,
    },
    {
      name: 'new_win_streak',
      path: '/win_streak/new',
      component: WinStreakAdd,
    },
    {
      path: '/win_streak/:winStreakId',
      component: WinStreak,
      props: parsePropsWinStreakId,
      redirect: {name: 'win_streak_info'},
      children: [
        {
          name: 'win_streak_info',
          path: 'info',
          component: WinStreakInfo,
          props: parsePropsWinStreakId,
        },
      ],
    },

    {
      name: 'daily_quests_timetable',
      path: '/daily_quests/timetable',
      component: DailyQuestsTimetable,
    },
    {
      name: 'new_daily_quests_timetable_record',
      path: '/daily_quests/timetable/add',
      component: AddDailyQuestsTimetableRecord,
    },
    {
      name: 'edit_daily_quests_timetable_record',
      path: '/daily_quests/timetable/:recordId/edit',
      component: EditDailyQuestsTimetableRecord,
      props: parsePropsDailyQuestId,
    },

    {
      path: '/river_rumble',
      component: RiverRumble,
      redirect: {name: 'river_rumble_timetable'},
      children: [
        {
          name: 'river_rumble_timetable',
          path: '/river_rumble/timetable',
          component: RiverRumbleTimetable,
        },
        {
          name: 'river_rumble_generate_players',
          path: '/river_rumble/generate_players',
          component: RiverRumbleDevGeneratePlayers,
        },
        {
          name: 'river_rumble_generate_stats',
          path: '/river_rumble/generate_stats',
          component: RiverRumbleDevGenerateStats,
        },
        {
          name: 'river_rumble_test_random_players',
          path: '/river_rumble/test_random_players',
          component: RiverRumbleDevTestRandomPlayers,
        },
        {
          name: 'river_rumble_test_simulate_join',
          path: '/river_rumble/test_simulate_join',
          component: RiverRumbleDevTestSimulateJoin,
        },
        {
          name: 'river_rumble_average_fails',
          path: '/river_rumble/average_fails',
          component: RiverRumbleAverageFails,
        }
      ],
    },
    {
      name: 'add_river_rumble_timetable_record',
      path: '/river_rumble/timetable/add',
      component: RiverRumbleTimetableAddRecord,
    },
    {
      name: 'edit_river_rumble_timetable_record',
      path: '/river_rumble/timetable/:recordId/edit',
      component: RiverRumbleTimetableEditRecord,
      props: parsePropsRiverRumbleId,
    },

    {
      path: '/derbies',
      component: Derbies,
      redirect: {name: 'derby_list'},
      children: [
        {
          name: 'derby_list',
          path: '/derbies',
          component: DerbyList,
        },
        {
          name: 'derby_template_list',
          path: '/derbies/templates',
          component: DerbyTemplateList,
        },
      ],
    },
    {
      name: 'derby_add',
      path: '/derbies/add',
      component: DerbyAdd,
    },
    {
      name: 'derby_template_add',
      path: '/derbies/templates/add',
      component: DerbyTemplateAdd,
    },

    {
      name: 'derby_template_edit',
      path: '/derbies/templates/:templateId/edit',
      component: DerbyTemplateEdit,
      props: parsePropsDerbyTemplateId,
    },

    {
      name: 'derby',
      path: '/derby/:derbyId',
      component: Derby,
      props: parsePropsDerbyId,
      children: [
        {
          name: 'derby_info',
          path: '/derby/:derbyId',
          component: DerbyInfo,
          props: parsePropsDerbyId,
        },
        {
          name: 'derby_leagues',
          path: 'leagues',
          component: DerbyLeagueList,
          props: parsePropsDerbyId,
        },
        {
          name: 'derby_races',
          path: 'races',
          component: DerbyRaceList,
          props: parsePropsDerbyRaces,
        },
      ],
    },

    {
      name: 'derby_race',
      path: '/derby_race/:raceId',
      component: DerbyRace,
      props: parsePropsDerbyRaceId,

      redirect: {name: 'derby_race_info'},
      children: [
        {
          name: 'derby_race_info',
          path: '/derby_race/:raceId',
          component: DerbyRaceInfo,
          props: parsePropsDerbyRaceId,
        },
        {
          name: 'derby_race_rating',
          path: 'rating',
          component: DerbyRaceRating,
          props: parsePropsDerbyRaceId,
        },
      ],
    },

    {
      name: 'derby_player',
      path: '/derby/:derbyId/player/:playerId',
      component: DerbyPlayer,
      props: parsePropsDerbyPlayerId,
      redirect: {name: 'derby_player_info'},
      children: [
        {
          name: 'derby_player_info',
          path: '/derby/:derbyId/player/:playerId',
          component: DerbyPlayerInfo,
          props: parsePropsDerbyPlayerId,
        },
        {
          name: 'derby_player_races',
          path: 'races',
          component: DerbyPlayerRaces,
          props: parsePropsDerbyPlayerId,
        },
      ],
    },

    {
      path: '/regattas',
      component: Regattas,
      redirect: {name: 'regatta_list'},
      children: [
        {
          name: 'regatta_list',
          path: '/regattas',
          component: RegattaList,
        },
      ],
    },
    {
      name: 'regatta_add',
      path: '/regattas/add',
      component: RegattaAdd,
    },

    {
      name: 'regatta',
      path: '/regattas/:regattaId',
      component: Regatta,
      props: parsePropsRegattaId,
      children: [
        {
          name: 'regatta_info',
          path: '/regattas/:regattaId',
          component: RegattaInfo,
          props: parsePropsRegattaId,
        },
        {
          name: 'regatta_rounds',
          path: 'rounds',
          component: RegattaRoundList,
          props: parsePropsRegattaRounds,
        },
      ],
    },

    {
      name: 'm3_replays',
      path: '/m3_replays',
      component: M3Replays,
    },

    {
      name: 'system',
      path: '/system',
      component: System,
      redirect: {name: 'system_client_min_version'},
      children: [
        {
          name: 'system_client_min_version',
          path: 'client_min_version',
          component: SystemClientMinVersion,
        },
        {
          name: 'system_maintenance',
          path: 'maintenance',
          component: SystemMaintenance,
        },
        {
          name: 'system_players_net_sessions_log_conf',
          path: 'players_net_sessions_log_conf',
          component: SystemPlayersNetSessionsLogConf,
        },
        {
          name: 'level_decrements',
          path: 'level_decrements',
          component: LevelDecrements,
        },
        {
          name: 'emergency_state_log',
          path: 'emergency_state_log',
          component: EmergencyStateLog,
        },
        {
          name: 'qa_users',
          path: 'qa_users',
          component: QAUsers,
        },
        {
          name: 'qa_user_add',
          path: 'qa_users/add',
          component: QAUserAdd,
        },
        {
          name: 'qa_user_edit',
          path: 'qa_users/:idType/:idValue',
          component: QAUserEdit,
          props: parsePropsQAUserId,
        },
        {
          name: 'system_insider_client_info',
          path: 'insider_client_info',
          component: SystemInfoInsiderClient,
        },
        {
          name: 'system_insider_server_info',
          path: 'insider_server_info',
          component: SystemInfoInsiderServer,
        },
        {
          name: 'system_game_server_info',
          path: 'game_server_info',
          component: SystemInfoGameServer,
        },
        {
          name: 'system_push_server_info',
          path: 'push_server_info',
          component: SystemInfoPushServer,
        },
        {
          name: 'system_redis_connection_stat',
          path: 'redis_connection_stat',
          component: SystemRedisConnectionStat,
        },
        {
          name: 'system_levels_revisions',
          path: 'levels_revisions',
          component: SystemLevelsRevisions,
        },
        {
          name: 'system_stat',
          path: 'stat',
          component: SystemStat,
        },
        {
          name: 'system_month_payer_groups',
          path: 'month_payer_groups',
          component: MonthPayerGroups,
        },
        {
          name: 'system_month_payer_group',
          path: 'month_payer_group/:groupYearMonth',
          component: MonthPayerGroup,
          props: parsePropsMonthPayerGroupId,
        },
        {
          name: 'system_test',
          path: 'test',
          component: SystemTest,
        },
      ],
    },
    {
      name: 'users',
      path: '/users',
      component: Users,
    },
    {
      name: 'user_add',
      path: '/users/add',
      component: UserAdd,
    },

    {
      path: '/user/:userId',
      component: User,
      props: parsePropsUserId,
      redirect: {name: 'user_info'},
      children: [
        {
          name: 'user_info',
          path: 'info',
          component: UserInfo,
          props: parsePropsUserId,
        },
        {
          name: 'user_change_password',
          path: 'info/change_password',
          component: UserChangePassword,
          props: parsePropsUserId,
        },
        {
          name: 'user_edit',
          path: 'info/edit',
          component: UserEdit,
          props: parsePropsUserId,
        },
        {
          name: 'user_actions',
          path: 'actions',
          component: UserActions,
          props: parsePropsUserId,
        },
      ],
    },

    // M3 levels
    {
      name: 'sequences',
      path: '/m3/sequences',
      redirect: `/m3/sequences/${MAIN_SEQUENCE_PROTO_ID}`,
    },
    {
      name: 'sequence_levels',
      path: '/m3/sequences/:sequence_id',
      component: Levels,
      props: route => {
        return {
          sequenceID: parseInt(route.params.sequence_id, 10),
          audienceId: parseOptionalIntQueryParam(route.query, 'audience'),
          startLevel: parseOptionalIntQueryParam(route.query, 'start_level'),
          endLevel:   parseOptionalIntQueryParam(route.query, 'end_level'),
          periodName: parseOptionalStringQueryParam(route.query, 'period'),
        };
      },
    },
    {
      name: 'm3_manager',
      path: '/m3/manager',
      component: LevelsConfPanel,
      redirect: {name: 'm3_reports_building'},
      children: [
        {
          name: 'm3_reports_building',
          path: 'reports_building',
          component: ReportsBuildingPanel,
        },
        {
          name: 'm3_invalid_level_proto_names',
          path: 'invalid_level_proto_names',
          component: InvalidLevelProtoNames,
        },
      ],
    },
    {
      name: 'sequence_level',
      path: '/m3/sequences/:sequence_id/level/:level_num',
      component: Level,
      props: route => {
        const sequenceId  = parseInt(route.params.sequence_id, 10);
        const levelNumber = parseInt(route.params.level_num, 10);

        const levelId = new LevelId(sequenceId, levelNumber);

        return {
          levelId: levelId,
          audienceId: parseOptionalIntQueryParam(route.query, 'audience'),
        };
      },
    },
    {
      name: 'sequence_level_var',
      path: '/m3/sequences/:sequence_id/level/:level_num/:level_id',
      component: LevelVar,
      props: route => {
        const sequenceId  = parseInt(route.params.sequence_id, 10);
        const levelNumber = parseInt(route.params.level_num, 10);
        const levelId     = parseInt(route.params.level_id, 10);

        const levelVarId = new LevelVarId(sequenceId, levelNumber, levelId);

        return {
          levelVarId: levelVarId,
          audienceId: parseOptionalIntQueryParam(route.query, 'audience'),
        };
      },
    },
    {
      name: 'm3_revision',
      path: '/m3/sequences/:sequence_id/level/:level_num/:level_id/revision/:revision',
      component: Revision,
      props: route => {
        const sequenceId  = parseInt(route.params.sequence_id, 10);
        const levelNumber = parseInt(route.params.level_num, 10);
        const levelId     = parseInt(route.params.level_id, 10);
        const revision    = parseInt(route.params.revision, 10);

        const revisionId = new RevisionId(sequenceId, levelNumber, levelId, revision);

        return {
          revisionId: revisionId,
          audienceId: parseOptionalIntQueryParam(route.query, 'audience'),
        };
      },
    },
    ////
    {
      name: 'error',
      path: '/error',
      component: ErrorPage,
    },
    {
      path: '*',
      redirect: '/',
    }
  ]
});
export default router;


router.beforeEach(checkLoginInfo);


function checkLoginInfo(to, from, next) {
  if(!isLoginRequired(to.name)) {
    next();
    return;
  }

  auth.isLoggedIn(onLoginInfoGot)
  function onLoginInfoGot(loggedIn, error) {
    if(error !== null) {
      console.log(error);
      next('/error');
      return;
    }

    if(!loggedIn) {
      next('/login');
      return;
    }
    next();
  }
}


function isLoginRequired(routeName) {
  if(routeName === 'login' || routeName === 'error') {
    return false;
  }
  return true;
}

setUnauthorizedHandler(goToLoginPage);
function goToLoginPage() {
  router.push({name: 'login'});
}

function parsePropsPlayerId(route) {
  return {
    playerId: parseInt(route.params.playerId, 10)
  };
}

function parsePropsPlayerBanAdd(route) {
  return {
    playerId: parseInt(route.params.playerId, 10),
    targetRoute: route.params.targetRoute,
  };
}

function parsePropsPlayerLevelFinishedEvents(route) {
  const page = parsePageNum(route.query.page);

  return {
    playerId: parseInt(route.params.playerId, 10),
    page: page,
  };
}

function parsePropsPushId(route) {
  return {
    pushId: parseInt(route.params.pushId, 10)
  };
}

function parsePropsClubId(route) {
  return {
    clubId: parseInt(route.params.clubId, 10)
  };
}

function parsePropsMassPendingId(route) {
  return {
    massPendingId: parseInt(route.params.massPendingId, 10),
  };
}

function parsePropsContestId(route) {
  return {
    contestId: parseInt(route.params.contestId, 10),
  };
}

function parsePropsContestGroups(route) {
  const contestId = parseInt(route.params.contestId, 10);
  const page = parsePageNum(route.query.page);

  return {
    contestId: contestId,
    page: page,
  };
}

function parsePropsRushId(route) {
  return {
    rushId: parseInt(route.params.rushId, 10),
  };
}

function parsePropsRushRaces(route) {
  const rushId = parseInt(route.params.rushId, 10);
  const page = parsePageNum(route.query.page);

  return {
    rushId: rushId,
    page: page,
  };
}

function parsePropsRushRaceId(route) {
  const rushId = parseInt(route.params.rushId, 10);
  const raceId = parseInt(route.params.raceId, 10);

  const rushRaceId = {
    rushId: rushId,
    raceId: raceId,
  };

  return {
    rushRaceId: rushRaceId
  };
}

function parsePropsSuspectedPlayers(route) {
  const page = parsePageNum(route.query.page);

  return {
    page: page,
  };
}

function parsePropsSuspectedPlayersBanAdd(route) {
  const playerIds = convertCSVStringToNumbers(route.query.player_ids);

  return {
    playerIds: playerIds,
  };
}

function parsePageNum(v) {
  if(v === undefined) {
    return undefined;
  }

  const pageNum = parseUint32(v);
  if(pageNum === null) {
    return undefined;
  }
  if(pageNum === 0) {
    return undefined;
  }

  return pageNum;
}

function parsePageSize(v) {
  const pageSize = parseUint32(v);
  if(pageSize === null) {
    return undefined;
  }

  return pageSize;
}

function parsePropsContestGroupId(route) {
  const contestId = parseInt(route.params.contestId, 10);
  const groupId   = parseInt(route.params.groupId, 10);

  const contestGroupId = {
    contestId: contestId,
    groupId: groupId,
  };

  return {
    contestGroupId: contestGroupId
  };
}

function parsePropsContestPlayerId(route) {
  const contestId = parseInt(route.params.contestId, 10);
  const playerId   = parseInt(route.params.playerId, 10);

  const contestPlayerId = {
    contestId: contestId,
    playerId: playerId,
  };

  return {
    contestPlayerId: contestPlayerId
  };
}

function parsePropsRushPlayerId(route) {
  const rushId   = parseInt(route.params.rushId,   10);
  const playerId = parseInt(route.params.playerId, 10);

  const rushPlayerId = {
    rushId:   rushId,
    playerId: playerId,
  };

  return {
    rushPlayerId: rushPlayerId
  };
}

function parsePropsRushRacePlayerId(route) {
  const rushId = parseInt(route.params.rushId, 10);
  const raceId = parseInt(route.params.raceId, 10);

  const rushRaceId = {
    rushId: rushId,
    raceId: raceId,
  };

  const playerId = parseInt(route.params.playerId, 10);

  return {
    rushRaceId: rushRaceId,
    playerId:   playerId,
  };
}

function parsePropsDerbyPlayerId(route) {
  const derbyId  = parseInt(route.params.derbyId,  10);
  const playerId = parseInt(route.params.playerId, 10);

  const derbyPlayerId = {
    derbyId:  derbyId,
    playerId: playerId,
  };

  return {
    derbyPlayerId: derbyPlayerId
  };
}

function parsePropsMesaId(route) {
  return {
    mesaId: parseInt(route.params.mesaId, 10),
  };
}

function parsePropsGvntId(route) {
  return {
    gvntId: parseInt(route.params.gvntId, 10),
  };
}

function parsePropsSeasonId(route) {
  return {
    seasonId: parseInt(route.params.seasonId, 10),
  };
}

function parsePropsMonthPayerGroupId(route) {
  return {
    groupYearMonth: route.params.groupYearMonth,
  };
}

function parsePropsWinStreakId(route) {
  return {
    winStreakId: parseInt(route.params.winStreakId, 10),
  };
}

function parsePropsQAUserId(route) {
  return {
    idType: parseInt(route.params.idType, 10),
    idValue: route.params.idValue,
  };
}

function parsePropsResourceLogCopyId(route) {
  return {
    playerId: parseInt(route.params.playerId, 10),
    copyId:   parseInt(route.params.copyId,   10),
  };
}

function parsePropsBanId(route) {
  return {
    playerId: parseInt(route.params.playerId, 10),
    banId:    parseInt(route.params.banId,    10),
  };
}

function parsePropsUnbanId(route) {
  return {
    playerId: parseInt(route.params.playerId, 10),
    unbanId:  parseInt(route.params.unbanId,  10),
  };
}

function parsePropsChatBlockId(route) {
  return {
    playerId:    parseInt(route.params.playerId,    10),
    chatBlockId: parseInt(route.params.chatBlockId, 10),
  };
}

function parsePropsChatUnblockId(route) {
  return {
    playerId:      parseInt(route.params.playerId,      10),
    chatUnblockId: parseInt(route.params.chatUnblockId, 10),
  };
}

function parsePropsInventoryItemId(route) {
  return {
    playerId: parseInt(route.params.playerId, 10),
    itemId:   parseInt(route.params.itemId,   10),
  };
}

function parsePropsOfferId(route) {
  return {
    playerId: parseInt(route.params.playerId, 10),
    offerId:  parseInt(route.params.offerId,  10),
  };
}

function parsePropsUserId(route) {
  return {
    userId: parseInt(route.params.userId, 10),
  };
}

function parsePropsDailyQuestId(route) {
  return {
    recordId: parseInt(route.params.recordId, 10),
  };
}

function parsePropsRiverRumbleId(route) {
  return {
    recordId: parseInt(route.params.recordId, 10),
  };
}

function parsePropsDerbyId(route) {
  return {
    derbyId: parseInt(route.params.derbyId, 10),
  };
}

function parsePropsDerbyRaces(route) {
  const derbyId = parseInt(route.params.derbyId, 10);
  const page = parsePageNum(route.query.page);
  const pageSize = parsePageSize(route.query.limit);

  return {
    derbyId: derbyId,
    page: page,
    pageSize: pageSize,
  };
}

function parsePropsDerbyRaceId(route) {
  return {
    raceId: parseInt(route.params.raceId, 10),
  };
}

function parsePropsRegattaId(route) {
  return {
    regattaId: parseInt(route.params.regattaId, 10),
  };
}

function parsePropsRegattaRounds(route) {
  const regattaId = parseInt(route.params.regattaId, 10)
  const page = parsePageNum(route.query.page)

  return {
    regattaId: regattaId,
    page: page,
  };
}

function parsePropsDerbyTemplateId(route) {
  return {
    templateId: parseInt(route.params.templateId, 10),
  };
}

function parseOptionalIntQueryParam(query, paramName) {
  if(!(paramName in query)) {
    return null;
  }
  const paramValue = query[paramName];

  if(paramValue === undefined) {
    return null;
  }

  return parseInt(paramValue, 10);
}

function parseOptionalStringQueryParam(query, paramName) {
  if(!(paramName in query)) {
    return null;
  }
  const paramValue = query[paramName];

  if(paramValue === undefined) {
    return null;
  }

  return paramValue;
}

//-----------------------------------------------------------------------------

function parseOptionalShopQueryParam(query, paramName) {
  if(!(paramName in query)) {
    return null;
  }
  const paramValue = query[paramName];

  if(paramValue === undefined) {
    return null;
  }

  return parseShop(paramValue);
}

//-----------------------------------------------------------------------------

router.beforeEach(waitProtoManagerInitialization);

function waitProtoManagerInitialization(to, from, next) {
  if(protoManager.isInited()) {
    next();
    return;
  }

  protoManager.addInitHandler(next);
}
